import { Component, OnInit } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
} from "@angular/forms";
import { AgentSkillService } from "@app/core/services/agent-skill.service";
import { ResultStatus } from "@app/core/models/result-status";
import { BsModalRef } from "ngx-bootstrap/modal";
import { HelperService } from "@app/core/services/helper.service";
import * as _ from "lodash";

@Component({
  selector: "app-add-skill",
  templateUrl: "./add-skill.component.html",
  styleUrls: ["./add-skill.component.scss"],
})
export class AddSkillComponent implements OnInit {
  skillForm: FormGroup;
  submitted = false;
  dropdownSkillList = [];
  dropdownSettings = {};
  selectedItems = [];

  constructor(
    private formBuilder: FormBuilder,
    private agentSKillService: AgentSkillService,
    public modalRef: BsModalRef,
    private helperService: HelperService
  ) {
    this.dropdownSettings = {
      singleSelection: false,
      idField: "item_id",
      textField: "item_text",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 3,
      allowSearchFilter: true,
    };
  }

  ngOnInit() {
    this.getSkillList();
    this.setSkillFormData();
  }

  getSkillList() {
    this.agentSKillService.getSkillList().subscribe((result) => {
      if (result.Status === ResultStatus.Success) {
        this.dropdownSkillList = result.Data;
        this.getSkills();
      }
    });
  }

  setSkillFormData() {
    this.skillForm = this.formBuilder.group({
      skill: new FormControl([], [Validators.required]),
    });
  }

  getSkills() {
    this.agentSKillService.getSkill().subscribe((result) => {
      if (result.Status === ResultStatus.Success) {
        const selectedSkill = _.map(result.Data, function (item, index) {
          return item.SkillId + "";
        });

        this.dropdownSkillList = this.dropdownSkillList.filter(function (item) {
          return selectedSkill.indexOf(item.Value) === -1;
        });
      }
    });
  }

  addSkill() {
    this.submitted = true;
    if (this.skillForm.invalid) {
      return;
    } else {
      const postData = this.skillForm.controls["skill"].value;
      const selctedSkill = [+this.skillForm.controls["skill"].value];

      this.agentSKillService.addSkill(selctedSkill).subscribe((result) => {
        if (result.Status === ResultStatus.Success) {
          this.modalRef.hide();
        }
      });
    }
  }
}
